import { PaginatorLaboratoryDynamicDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-dynamic-datasource'
import laboratoryDynamicServices from '@/modules/laboratoryModule/services/laboratoryDynamicServices'
import { CommonFilterModel, CommonSortModelResource } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

export class LaboratoryDatasource<T> extends PaginatorLaboratoryDynamicDatasource<T> {
    private readonly _sectionIds: number[]

    constructor(laboratoryId: number, url: string, sectionIds: number[]) {
        super(laboratoryDynamicServices, laboratoryId, url)
        this._sectionIds = sectionIds
    }

    paginator(
        filterModel: CommonFilterModel,
        sortModel: CommonSortModelResource[],
        page: number = 0,
        size: number = 20
    ): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }

        laboratoryDynamicServices.cancelAxiosCall()

        const params = {
            sectionIds: this._sectionIds,
            sort: GridUtils.getSortValue(sortModel),
            page,
            size
        }
        return this.service.paginator(filterModel, params, this.laboratoryId, this._url)
    }
}
